import { Link } from 'react-router-dom';
import { InstitutionLogo } from '../common/InstitutionLogo';

export function Footer({ showInstitution = true }: { showInstitution?: boolean }) {
  return (
    <footer className="border-t border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        {showInstitution && <div className="grid items-center gap-8 py-10 lg:grid-cols-[minmax(0,1fr)_auto]">
          <div>
            <p className="mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-primary-600 dark:text-primary-400">Developed at</p>
            <p className="text-base font-semibold leading-relaxed text-gray-900 dark:text-gray-100">
              <a href="https://kpi.fei.tuke.sk/en" target="_blank" rel="noopener noreferrer" className="hover:underline">Department of Computers and Informatics<span className="sr-only"> (opens in a new tab)</span></a>
            </p>
            <p className="mt-1 text-sm leading-relaxed text-gray-600 dark:text-gray-300">Faculty of Electrical Engineering and Informatics<br />Technical University of Košice<br />Slovakia</p>
          </div>
          <div className="flex flex-wrap items-center gap-4">
            <InstitutionLogo institution="fei" />
            <InstitutionLogo institution="tuke" />
          </div>
        </div>}
        <div className={`flex flex-wrap items-center justify-between gap-x-8 gap-y-4 py-5 text-xs text-gray-500 dark:text-gray-400 ${showInstitution ? 'border-t border-gray-200 dark:border-gray-700' : ''}`}>
          <p><Link to="/" className="mr-2 font-semibold text-gray-700 hover:text-primary-600 dark:text-gray-200 dark:hover:text-primary-300">Rocq Game</Link> An academic environment for learning and formal reasoning.</p>
          <nav aria-label="Project information" className="flex flex-wrap gap-x-5 gap-y-2">
            <Link to="/worlds" className="hover:text-primary-600 hover:underline dark:hover:text-primary-300">Worlds</Link>
            <Link to="/help" className="hover:text-primary-600 hover:underline dark:hover:text-primary-300">Help & Tutorial</Link>
            <Link to="/about" className="hover:text-primary-600 hover:underline dark:hover:text-primary-300">About Rocq Game</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
